/** @format */

import {
  Box,
  Button,
  Modal,
  ArrowRight2,
} from "../../../common/utils/mui-imports";
import HPRDataGrid from "../../../components/common/HPRDataGrid/HRPDataGrid";
import { HPRDataGridToolbarProps } from "../../../components/common/HPRDataGrid/HPRDataGrid.types";
import { ViewBulkDetailsPopupProps } from "./ViewBulkDetailsPopup.types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ViewBulkDetailsPopup: React.FC<ViewBulkDetailsPopupProps> = (props) => {
  return (
    <Modal
      className="modal-outter"
      open={props.open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="question-summary lg" sx={style}>
        <div className="d-flex no-wrap new-modal-header">
          <h1
            className="page-title no-wrap limit-1"
            style={{ maxWidth: "30vw" }}
          >
            {props.title}
          </h1>

          <span className="d-flex pl-10 pr-10 fx-align-center arrow-separator">
            <ArrowRight2 size="20" color="#023047" />
          </span>
          <h1>{props.subtitle}</h1>
        </div>
        <div className="modal-content border-none read-only">
          <div className="new-grid-style HPRDataGrid-wrapper remedation-tra-tas strikeout-wrapper">
            <HPRDataGrid
              ShowCustomePagination
              Columns={props.columns}
              Data={props.data}
              TotalRecordsCount={props.totalRecordsCount}
              AutoHeight={true}
              onPaginationChangeCallBack={() => {
                if (!props.onPaginationChange) return props.onPaginationChange;
              }}
              SelectedPage={props.selectedPage}
              HPRDataGridToolbarProps={
                {
                  ShowTotalRecordsCount: true,
                } as HPRDataGridToolbarProps
              }
              PageSize={props.pageSize}
            />
          </div>
        </div>

        <div className="modal-button-bar">
          <Button
            className="secondary-btn-small"
            variant="outlined"
            disableElevation
            onClick={(e) => {
              e.stopPropagation();
              if (!props.onClose) return;

              props.onClose();
            }}
          >
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ViewBulkDetailsPopup;
